import clsx from 'clsx'

import type { DisclosableItemCardWrapperProps } from './type'

import { Disclosure } from '@/components/ui'

export const DisclosableItemCardWrapper = ({
  isOpen,
  disabled,
  selectable,
  headingNode,
  detailContentNode,
  toggle,
}: DisclosableItemCardWrapperProps) => {
  return (
    <Disclosure
      isOpen={isOpen}
      disabled={disabled}
      toggle={toggle}
      heading={headingNode}
    >
      <div className={clsx(selectable && 'tw-ml-6')}>
        <div className={clsx('tw-px-2')}>{detailContentNode}</div>
      </div>
    </Disclosure>
  )
}
